// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#expertise .card-body:not(:nth-child(2)){border-top:1px solid rgba(0,0,0,.125)}", ""]);
// Exports
module.exports = exports;
